/**
 * 装飾カラム（選手ビジュアル）のスライドイン
 *
 * 動き自体はCSS（.js-slide-in → .active）が持っているため、
 * ここでは画面内に入ったタイミングで .active を付けるだけに留める。
 */
export const initSlideIn = () => {
  const elements = document.querySelectorAll(".js-slide-in");
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("active");
        // 一度表示したら監視を解除（再生は1回だけ）
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: "-15% 15%",
      threshold: [0, 0.2, 0.3, 0.5, 1],
    },
  );

  elements.forEach((element) => observer.observe(element));
};
